<template>
    <div class="containerRepresentante">
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="titleForm" style="display: inline-flex">
                <div class="categoriaAgrupamentoFormulario" style="width: 120%">
                    <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Procuradores'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Procuradores'" :SubSessao="'Procuradores'" />
                    <h5 class="title">Clique em adicionar se possuir procuradores. Você pode adicionar quantas pessoas
                        desejar.</h5>
                </div>
            </div>
            <div class="titleForm">
                <div class="opcoesForm" v-if="listaRepresentantes.length == 0">
                    <div v-if="!consultaProgresso">
                        <img src="@/assets/addRepresentante.png" />
                        <h3>Nenhuma pessoa adicionada.</h3>
                    </div>
                    <div v-if="consultaProgresso" class="spinner"></div>
                </div>

                <div v-if="listaRepresentantes.length > 0">
                   <div class="grid-desktop">
                    <table class="table">
                        <thead>
                            <th style="width: 20%">Nome e E-mail</th>
                            <th style="width: 20%">Documento</th>
                            <th style="width: 15%">Emissor de Ordem</th>
                            <th style="width: 15%">US Person</th>
                            <th style="width: 10%">Politicamente exposta</th>
                            <th style="width: 15%">Assinatura</th>
                            <th style="width: 20%">&nbsp;</th>
                        </thead>
                        <tbody>
                            <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index">
                                <td><span class="destaque">{{ representanteObj.Nome }} </span> {{ representanteObj.Email }}</td>
                                <td>{{ representanteObj.TipoDocumento}} - {{ formatCpfCnpj(representanteObj.CpfCnpj) }}</td>
                                <td>{{ representanteObj.EmissorOrdem == true ? "Sim" : "Não" }}</td>
                                <td>{{ representanteObj.UsPerson == true ? "Sim" : "Não" }}</td>
                                <td>{{ representanteObj.PoliticamenteExposta == true ? "Sim" : "Não" }}</td>
                                <td>{{ representanteObj.AssinaturaFormatada }}</td>
                                <td>
                                    <div class="widget icons" style="display: inline-flex">
                                        <a @click.stop.prevent="editarRepresentante(index)" class="ico__edit"
                                            title="editar">
                                            <Icon icon="ico-edit" />
                                        </a>
                                        <!-- v-if="politicaSelecionada == null || (politicaSelecionada != null && politicaSelecionada.guid == item.guid)" -->
                                        <a 
                                            @click.stop.prevent="deletarRepresentante(index)" class="ico__delete"
                                            title="deletar" style="margin-left: 5px">
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </div>

                 <div class="grid-mobile" v-if="!editFormMobile" style="display: none">
                       <div class="rows__carteiras">
                        <div class="header__row">
                            <div class="widget">
                                <p>Nome</p>
                            </div>

                            <div class="widget">
                                <p>E-mail</p>
                            </div>

                            <div class="widget">
                                <p>CPF/CNPJ/Outros</p>
                            </div>
                            <div class="widget">
                                <p>Emissor de Ordem</p>
                            </div>

                            <div class="widget">
                                <p>US Person</p>
                            </div>

                            <div class="widget">
                                <p>Politicamente exposta</p>
                            </div>

                            <div class="widget">
                                <p>Assinatura</p>
                            </div>


                        </div>

                        <div
                            v-for="(representanteObj, index) in listaRepresentantes" :key="index"
                        >
                            <div
                                class="row__client"
                                v-if="representanteObj.Nome"
                            >
                                <div class="info__client">                                

                                    <div class="widget">
                                        <p class="title__mobile">Nome</p>


                                        <p>{{ representanteObj.Nome }}</p>
                                    </div>

                                    <div class="widget">
                                        <p class="title__mobile">E-mail</p>


                                        <p>{{ representanteObj.Email }}</p>
                                    </div>

                                    <div class="widget">
                                        <p class="title__mobile">{{representante.TipoDocumento}}</p>
                                        <p>{{ representanteObj.CpfCnpj }}</p>
                                    </div>

                                    <div class="widget">
                                        <p class="title__mobile">Emissor de ordem</p>
                                        <p>
                                            {{ representanteObj.EmissorOrdem == true ? "Sim" : "Não" }}
                                        </p>
                                    </div>

                                    <div class="widget">
                                        <p class="title__mobile">US Person</p>
                                        <p>
                                            {{ representanteObj.UsPerson == true ? "Sim" : "Não" }}
                                        </p>
                                    </div>

                                     <div class="widget">
                                        <p class="title__mobile">Politicamente exposta</p>
                                        <p>
                                            {{ representanteObj.PoliticamenteExposta == true ? "Sim" : "Não" }}
                                        </p>
                                    </div>

                                    <div class="widget">
                                        <p class="title__mobile">Assinatura</p>
                                        <p>
                                            {{ representanteObj.AssinaturaFormatada }}
                                        </p>
                                    </div>

                                    <div class="widget icons" style="display: inline-flex">

                                        <a @click.stop.prevent="editarRepresentante(index, true)" class="ico__edit"
                                            title="editar">
                                            <Icon icon="ico-edit" />
                                        </a>
                                        <a 
                                            @click.stop.prevent="deletarRepresentante(index)" class="ico__delete"
                                            title="deletar" style="margin-left: 5px">
                                        </a>

                                    </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>


                </div>
            </div>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados procurador'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Procuradores'" :SubSessao="'Procuradores'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 33%">
                            <label class="label" for="nome">Nome*</label>
                            <input class="field" type="text" id="nome" v-model="representante.Nome">
                            <p v-if="camposObrigatorios.erroNome" class="erro">Campo obrigatório.</p>
                        </div>
                        
                        <!-- Tipo de Documento (Novo campo) -->
                        <div class="label__field" style="width: 33%">
                            <label class="label" for="tipoDocumento">Tipo de Documento*</label>
                            <select class="field" id="tipoDocumento" v-model="representante.TipoDocumento" @change="aoMudarTipoDocumento">
                                <option value="CPF">CPF</option>
                                <option value="CNPJ">CNPJ</option>
                                <option value="CNH">CNH</option>
                                <option value="RNE">RNE</option>
                            </select>
                            <p v-if="camposObrigatorios.erroTipoDocumento" class="erro">Campo obrigatório.</p>
                        </div>

                          <div class="label__field" style="width: 33%">
                            <label class="label" for="cpf">{{ obterLabelDocumento }}*</label>
                            <input class="field" type="text" id="cpf" v-model="representante.CpfCnpj"
                                v-mask="obterMascaraDocumento"
                                :placeholder="obterPlaceholderDocumento"
                                @change="validarDocumento">
                            <p v-if="camposObrigatorios.erroCpfCnpj" class="erro">Campo obrigatório.</p>
                            <p v-if="erroDocumento" class="erro">{{ mensagemErro }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Campo de documento modificado -->
                        
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">E-mail*</label>
                            <input class="field" type="text" id="email" v-model="representante.Email"
                                @blur="validarEmail">
                            <p v-if="emailErros.email" class="erro">{{ emailErros.email }}</p>
                        </div>
                        
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Cargo</label>
                            <input class="field" type="text" id="cargo" v-model="representante.Cargo">
                        </div>

                          <div class="label__field" style="width: 30%">
                            <telefone-internacional
                                v-model="representante.Telefone" 
                                label="Telefone*" 
                                name="Telefone"
                                @validate="onValidateTelefone"
                            />
                            <p v-if="camposObrigatorios.erroTelefone" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    
                    <div class="row">
                        
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" id="cep" v-model="representante.Cep" @change="validarCep(representante)">
                            <p v-if="camposObrigatorios.erroCep" class="erro">Campo obrigatório.</p>
                        </div>
                        
                        <div class="label-cep" style="width: 8%; margin-top: 35px;">
                            <a class="custom-link" target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não
                                sei o CEP</a>
                        </div>

                    <div class="label__field" style="width: 47%">
                            <label class="label" for="cpf">Endereço/Logradouro*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" id="endereco"
                                v-model="representante.Logradouro">
                            <p v-if="camposObrigatorios.erroLogradouro" class="erro">Campo obrigatório.</p>
                    </div>
                    <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Número*</label>
                            <input class="field" type="text" id="numero" v-model="representante.Numero"
                                >
                            <p v-if="camposObrigatorios.erroNumero" class="erro">Campo obrigatório.</p>
                    </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" id="complemento" v-model="representante.Complemento">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Bairro*</label>
                            <input class="field" :disabled="isDisabledEnderecoLogradouro" type="text" id="bairro"
                                v-model="representante.Bairro">
                            <p v-if="camposObrigatorios.erroBairro" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Cidade*</label>
                            <input class="field" :disabled="isDisabledEndereco" type="text" id="cidade"
                                v-model="representante.Cidade">
                            <p v-if="camposObrigatorios.erroCidade" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">UF*</label>
                            <select class="field" :disabled="isDisabledEndereco" id="uf" v-model="representante.Uf" @change="salvarAlteracoesLocalmente">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroUF" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">País*</label>
                            <select id="pais" class="field"
                                v-model="representante.Pais" :disabled="isDisabledEndereco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <div class="form__controls" style="width: 100%">
                                <label class="label" for="nome">Considerado US Person?*</label>
                                <div class="radio">
                                    <input type="radio" id="false" name="UsPerson" class="field__radio" value="false"
                                        v-model="representante.UsPerson" />
                                    <label for="Nao" class="label__radio">Não</label>
                                    <input type="radio" id="true" value="true" name="UsPerson"
                                        class="field__radio field__radio_second" v-model="representante.UsPerson" />
                                    <label for="Sim" class="label__radio">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <div class="form__controls" style="width: 100%">
                                <label class="label" for="nome">Politicamente Exposto?*</label>
                                <div class="radio">
                                    <input type="radio" id="false" name="PoliticamenteExposta" class="field__radio"
                                        value="false" v-model="representante.PoliticamenteExposta" />
                                    <label for="Nao" class="label__radio">Não</label>
                                    <input type="radio" id="true" value="true" name="PoliticamenteExposta"
                                        class="field__radio field__radio_second"
                                        v-model="representante.PoliticamenteExposta" />
                                    <label for="Sim" class="label__radio">Sim</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="assinante">Assinatura*</label>
                            <select id="assinante" class="field" v-model="representante.Assinatura"
                                >
                                <option value="">Selecione</option>
                                <option value="1">Não assina pela empresa</option>
                                <option value="2">Assina isoladamente</option>
                                <option value="0">Assina em conjunto</option>
                            </select>
                            <p v-if="camposObrigatorios.erroAssinatura" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" type="button" style="width: 80px; height: 40px;"
                            @click="limparRepresentante">Cancelar</button>
                        <button class="btnBlue" type="button" v-if="representante.Guid == ''"
                            :disabled="disableBtnSalvarRepresentante" @click="incluirPessoa">Adicionar</button>
                        <button class="btnBlue" type="button" v-if="representante.Guid != ''"
                            :disabled="disableBtnSalvarRepresentante"
                            @click="atualizarPessoa">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
import api from '@/api/axios';
import { validarCampoCep, ufs } from '@/utils/formUtils';
import { mask } from 'vue-the-mask';
import documentoUtils from '@/utils/documentoUtils';

export default {
    name: 'CadastroPJ_Procuradores',
    props: ['Edicao'],
    mixins: [formatCpfCnpj, emailValidatorMixin],
    components: { LabelDisclaimer },
    directives: {
        mask
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_PROCURADORES_PJ',
            listaPaises: 'GET_LISTA_PAISES',
        }),
        celularMask() {
            const telefoneLimpo = this.representante.Telefone?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
        obterLabelDocumento() {
            if (!this.representante || !this.representante.TipoDocumento) return 'CPF';
            return documentoUtils.obterLabelDocumento(this.representante.TipoDocumento);
        },
        obterMascaraDocumento() {
            if (!this.representante || !this.representante.TipoDocumento) return '###.###.###-##';
            return documentoUtils.obterMascaraDocumento(this.representante.TipoDocumento);
        },
        obterPlaceholderDocumento() {
            if (!this.representante || !this.representante.TipoDocumento) return '000.000.000-00';
            return documentoUtils.obterPlaceholderDocumento(this.representante.TipoDocumento);
        },
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            telefoneValido: [],
            permitirAvancar: false,
            erroDocumento: false,
            emailErros: {},
            camposObrigatorios: {
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroTelefone: false,
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUF: false,
                erroPais: false,
                erroAssinatura: false
            },
            disableBtnSalvarRepresentante: false,
            isDisabledEndereco: false,
            isDisabledEnderecoLogradouro: false,
            editFormMobile: false,
            consultaProgresso: true,
            representante: {
                Guid: '',
                ClienteId: '',
                Nome: '',
                CpfCnpj: '',
                Email: '',
                Cargo: '',
                Telefone: '',
                Cep: '',
                Logradouro: '',
                Numero: '',
                Complemento: '',
                TipoDocumento: '',
                Bairro: '',
                Cidade: '',
                Uf: '',
                Pais: '',
                Tipo: 'Procurador',
                EmissorOrdem: false,
                UsPerson: false,
                PoliticamenteExposta: false,
                Assinatura: ''
            },
            mensagemErro: ''
        }
    },
    created() {
        this.$store.dispatch('FETCH_PJ_LISTA_PROCURADORES', this.user.ClienteId);
    },
    mounted() {
        this.$store.commit('SET_PJ_SALVAR_INFO', false);
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA', false);
        this.representante.ClienteId = this.user.ClienteId;

        if(this.listaRepresentantes != null){
            this.consultaProgresso = false;
        }

    },
    watch: {
        listaRepresentantes() {
            this.consultaProgresso = false;
        }
    },
    methods: {
        onValidateTelefone({ name, valid }) {
            if (!this.telefoneValido) {
                this.telefoneValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneValido[name] = valid;
            }
        },
        validarEmail() {
            var retorno = this.validarEmailGeneric(this.representante.Email, 'email', {
                obrigatorio: true,
            });

            if(retorno == true){
                //this.salvarAlteracoesLocalmenteRepresentante();
            }
        },
        aoMudarTipoDocumento() {
            if (!this.representante) return;
            
            // Limpa o campo quando o tipo de documento muda
            this.representante.CpfCnpj = '';
            this.erroDocumento = false;
            this.mensagemErro = '';
            
            //this.salvarAlteracoesLocalmenteRepresentante();
        },
        
        // Método para validar o documento
        validarDocumento() {
            if (!this.representante) return;
            
            if (this.representante.CpfCnpj) {
                const resultado = documentoUtils.validarDocumentoCompleto(
                    this.representante.CpfCnpj, 
                    this.representante.TipoDocumento || 'CPF'
                );
                this.erroDocumento = !resultado.valido;
                this.mensagemErro = resultado.mensagem;
                
                // Se o documento for inválido, volte o foco para o campo
                if (!resultado.valido && this.representante.CpfCnpj != '') {
                    this.$nextTick(() => {
                        const inputElement = document.getElementById('cpf');
                        if (inputElement) {
                            inputElement.focus();
                        }
                    });
                }
            } else {
                this.erroDocumento = false;
                this.mensagemErro = '';
            }
            
            //this.salvarAlteracoesLocalmenteRepresentante();
        },
        async validarCep(objDados, somenteValidar = false) {
            var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar });
            if (result) {
                this.isDisabledEndereco = true;
                this.isDisabledEnderecoLogradouro = true;
                if (objDados.Logradouro == '') {
                    this.isDisabledEnderecoLogradouro = false;
                }
            } else {
                this.isDisabledEndereco = false;
                this.isDisabledEnderecoLogradouro = false;
            }
        },
        proximaEtapa() {
            this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
            this.$store.commit('SET_ETAPA_CADASTRO', 2);
        },
        validarFormulario(submeter) {
            if(submeter != true)
                return;
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroTelefone: false,
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUF: false,
                erroPais: false,
                erroAssinatura: false
            };
            if (!this.representante.Nome) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNome = true;
                    nomeDoCampo = 'Nome';
                }
                this.permitirAvancar = false;
            }

            if (!this.representante.CpfCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCpfCnpj = true;
                    nomeDoCampo = this.obterLabelDocumento;
                }
                this.permitirAvancar = false;
            } else if (this.erroDocumento) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCpfCnpj = true;
                    nomeDoCampo = this.obterLabelDocumento;
                }
                this.permitirAvancar = false;
            }

            if (Object.values(this.emailErros).some(erro => erro !== '')) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEmail = true;
                    nomeDoCampo = 'E-mail';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Telefone || !this.telefoneValido?.Telefone) {
            if (submeter && this.permitirAvancar) {
                this.camposObrigatorios.erroTelefone = true;
                nomeDoCampo = 'Telefone';
            }
            this.permitirAvancar = false;
            } else {
            this.camposObrigatorios.erroTelefone = false;
            }
            if (!this.representante.Cep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCep = true;
                    nomeDoCampo = 'CEP';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Logradouro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroLogradouro = true;
                    nomeDoCampo = 'Logradouro';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Numero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNumero = true;
                    nomeDoCampo = 'Numero do endereço';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Bairro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroBairro = true;
                    nomeDoCampo = 'Bairro';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Cidade) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCidade = true;
                    nomeDoCampo = 'Cidade';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Uf) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroUF = true;
                    nomeDoCampo = 'UF';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Pais) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroPais = true;
                    nomeDoCampo = 'País';
                }
                this.permitirAvancar = false;
            }
            if (this.representante.Assinatura === null || this.representante.Assinatura === undefined || this.representante.Assinatura === '') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroAssinatura = true;
                    nomeDoCampo = 'Assinatura';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        salvarInformacoes() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
            if (this.representante.Guid != '') {
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.atualizarPessoa();
            }
        },
        async incluirPessoa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.disableBtnSalvarRepresentante = true;
                 
                this.representante.ClienteId = this.user.ClienteId;
                await api
                    .post('/PessoaJuridica/representante/salvar', this.representante)
                    .then((retorno) => {
                        this.disableBtnSalvarRepresentante = false;
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: 'Inclusão realizada com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                            this.limparRepresentante();
                            this.$store.dispatch('FETCH_PJ_LISTA_PROCURADORES', this.user.ClienteId);
                        }
                    })
                    .catch((error) => {
                        this.disableBtnSalvarRepresentante = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos para procurador.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            } else {
                this.$store.commit('SET_PJ_SALVAR_INFO', false);
            }
        },
        async atualizarPessoa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.disableBtnSalvarRepresentante = true;
                 
                this.representante.ClienteId = this.user.ClienteId;
                await api
                    .post('/PessoaJuridica/representante/atualizar', this.representante)
                    .then((retorno) => {
                        this.disableBtnSalvarRepresentante = false;
                        this.editFormMobile = false;
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: 'Alteração realizada com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                            this.limparRepresentante();
                            this.$store.dispatch('FETCH_PJ_LISTA_PROCURADORES', this.user.ClienteId);                            
                        }
                    })
                    .catch((error) => {
                        this.disableBtnSalvarRepresentante = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos para procurador.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            } else {
                this.$store.commit('SET_PJ_SALVAR_INFO', false);
            }
        },
        editarRepresentante(index, isMobile) {
            this.representante = JSON.parse(JSON.stringify(this.listaRepresentantes[index]));
            this.validarCep(this.representante, true);

            if(isMobile){
                this.editFormMobile = true;
            }
        },
        limparRepresentante() {
            this.representante.Guid = '';
            this.representante.ClienteId = this.user.ClienteId;
            this.representante.Nome = '';
            this.representante.CpfCnpj = '';
            this.representante.Email = '';
            this.representante.Cargo = '';
            this.representante.TipoDocumento = '';
            this.representante.Telefone = '';
            this.representante.Cep = '';
            this.representante.Logradouro = '';
            this.representante.Numero = '';
            this.representante.Complemento = '';
            this.representante.Bairro = '';
            this.representante.Cidade = '';
            this.representante.Uf = '';
            this.representante.Pais = '';
            this.representante.Tipo = 'Procurador'; // Mantém o valor padrão
            this.representante.EmissorOrdem = false;
            this.representante.UsPerson = false;
            this.representante.PoliticamenteExposta = false;
            this.representante.Assinatura = '';
            this.camposObrigatorios = {
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroTelefone: false,
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUF: false,
                erroPais: false,
                erroAssinatura: false
            };
            this.editFormMobile = false;
        },
        async deletarRepresentante(index) {
            this.disableBtn = true;
             
            await api.get(`PessoaJuridica/representante/excluir?guid=${this.listaRepresentantes[index].Guid}&tipo=${this.listaRepresentantes[index].Tipo}`)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_PJ_LISTA_PROCURADORES', this.user.ClienteId);
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.field__radio {
    margin-top: -2px;
    width: 20px;
    height: 20px;
}

</style>